import unit from "../../../utils/unit";
export var modalLargeMaxWidthUnit = 904;
export var modalMiddleMaxWidthUnit = 544;
export var modalMarginUnit = 8;
export var scrollbarCollor = "\n  &::-webkit-scrollbar-track {\n    background-color: rgba(33, 33, 33, 0.7);\n  }\n\n  &::-webkit-scrollbar {\n    width: ".concat(unit(6), ";\n    background-color: rgba(245, 245, 245, 0.1);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(245, 245, 245, 0.3);\n  }\n");